import React, {Component} from 'react';
import {Modal, Table} from 'react-bootstrap';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import FlatButton from 'material-ui/FlatButton';
import moment from 'moment';

var Config = require('../../../config');

class ModalInfo extends Component{
	constructor(props){
		super(props);

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);

		this.state = {
			show: false,
			unit: {},
			list_donation_type:[],
			origin_list:[],
			blood_component_list:[],
			biometrics:[],
			show_patient:false,
			national_centers:[],
			relationships:[],
			analitical_test_list:[],
			table_required:[],
			table_other:[],
			other_test:[],
		}
	}

	componentDidMount(){
		this.props.onRef(this);
	}

	componentWillUnmount(){
		this.props.onRef(null);
	}

	handleShow(id){
		this.props.waiting.handleShow('Cargando...');

		this.getDonationType();
		this.getOriginList();
		this.getBloodComponent();
		this.getBiometrict();
		this.getNationalCenter();
		this.getRelationship();
		this.getAnaliticalRequire();
		this.getOtherTest();

		this.setState({show:true});
		setTimeout(()=>{
			fetch(Config.default.apiGateway.URL+'unit_entries/'+id,{
				method: 'get',
				headers: new Headers({
					'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res => {
				if(res.ok){
					return res.json();
				}else{
					res.text().then((msg)=>{
						swal('Error', msg, 'error');
					});
				}
			}).then(response => {
				if(response !== undefined){
					this.setState({
						unit: response,
					});

					if(response.person !== null){
						this.setState({show_patient: true});
					}
					
					response.analitical_test_required.map((test)=>{
						var index = this.state.analitical_test_list.findIndex(obj =>
							obj.analitical_test.id === test.analitical_test_id
						);

						if(index !== -1){
							this.setState({
								table_required: [...this.state.table_required, {
									name: this.state.analitical_test_list[index].analitical_test.name,
									value: test.value
								}]
							});
						}

						
					});


					this.props.waiting.handleClose();
				}
			});
		}, 500);
			
	}

	getDonationType(){
		fetch(Config.default.apiGateway.URL+'donation_type/actives', {
			method: 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response =>{
			if(response !== undefined){
				this.setState({
					list_donation_type: response
				});
			}
		});
	}

	getOriginList(){
		fetch(Config.default.apiGateway.URL+'health_facilities?option=distribution', {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response=>{
			if(response !== undefined){
				this.setState({
					origin_list: response
				});
			}
		});
	}

	getBloodComponent(){
		fetch(Config.default.apiGateway.URL+'blood_component', {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					blood_component_list: response
				})
			}
		});
	}

	getBiometrict(){
		fetch(Config.default.apiGateway.URL+'biometrics?option=biometrics_for_entry_units&sex=',{ 
	        method: 'get',
	        headers: new Headers({
	           'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
	           'Accept': 'application/json',
	            'Content-Type': 'application/json',
	        })
	    })
	    .then(response => response.json())
	    .then(response => {
	      this.setState({biometrics: response});	      
	    })
	}

	getNationalCenter(){
		//national centers
		fetch(Config.default.apiGateway.URL+'national_centers?option=offers&health_facility='+
			sessionStorage.getItem("health_facilities_id"),{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
		      national_centers: response
		    });
		});
	}

	getRelationship(){
		//parentesco
		fetch(Config.default.apiGateway.URL+'lookups?type=FAMILIAR_RELATIONSHIP&option=actives&order=true',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
		      relationships: response
		    });
		})
	}

	getAnaliticalRequire(){
		fetch(Config.default.apiGateway.URL+'analitical_test?id=0&option=required_nom', {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				response.map((r, i)=>{
					r.checkbox = {
						id: 'check_test_'+r.analitical_test.id,
						checked: true
					}
				});

				this.setState({analitical_test_list: response});
			}
		});
	}

	getOtherTest(){
		fetch(Config.default.apiGateway.URL+'analitical_test?id=0&option=list',{ 
	        method: 'get',
	        headers: new Headers({
	           'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
	           'Accept': 'application/json',
	            'Content-Type': 'application/json',
	        })
	    })
	    .then(response => response.json())
	    .then(response => {
	      	this.setState({
	      		other_test: response, 
	      	});
	    });
	}

	handleClose(){
		this.setState({show: false, table_required:[]});
	}

	render(){
		const {t} = this.props;
		var item = this.state.unit; 
		return (
			<Modal bsSize="lg" show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>Detalles</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row">
		        		<div className="col-xs-12">
		        			<fieldset className="col-xs-12">
		        				<legend>Unidad</legend>
		        				<div>
			        				<div className="col-xs-12 col-sm-2">
			        					<span>Fecha de Entrada</span>
			        					<input value={item.unit_entries !== undefined ? 
			        						moment(item.unit_entries.entry_date, 'YYYY-MM-DD').format('DD/MM/YYYY') : ""} className="form-control" disabled />
			        				</div>
			        				<div className="col-xs-12 col-sm-2">
			        					<span>Fecha de Donación</span>
			        					<input value={item.unit_entries !== undefined ? 
			        						item.unit_entries.donation_date !== null ?
			        							moment(item.unit_entries.donation_date, 'YYYY-MM-DD').format('DD/MM/YYYY') : ""
			        						: ""} 
			        						className="form-control" disabled />
			        				</div>
			        				<div className="col-xs-12 col-sm-4">
			        					<span>Origen</span>
			        					
			        					<select className="form-control" disabled value={item.unit !== undefined ? item.unit_entries.national_center_origin_id : ''} >
			        						{this.state.origin_list.map((list, i)=>{
												return <option key={i} value={list.id}>
													{list.name}
												</option>
											})}
			        					</select>
			        				</div>
			        				<div className="col-xs-12 col-sm-2">
			        					<span>Tipo de Donación</span>
			        					<select className="form-control" disabled value={item.unit !== undefined ? item.unit_entries.donation_type_id : ''}>
			        						{this.state.list_donation_type.map((item, i)=>{
												return <option key={i} value={item.donation_type.id}>
													{item.lookup_value}
												</option>
											})}
			        					</select>
			        				</div>
		        				
			        				<div className="col-xs-12 col-sm-2">
			        					<span>Número de Unidad</span>
			        					<input value={item.unit !== undefined ? item.unit.unit_number : ''} className="form-control" disabled />
			        				</div>
			        				<div className="col-xs-12 col-sm-2">
			        					<span>Número de origen</span>
			        					<input value={item.unit !== undefined ? item.unit_entries.origin_unit_number : ''} className="form-control" disabled />
			        				</div>
			        				<div className="col-xs-12 col-sm-2">
			        					<span>No. Componente</span>
			        					<input value={item.unit !== undefined ? item.unit.component_number : ''} className="form-control" disabled />
			        				</div>
			        				<div className="col-xs-12 col-sm-4">
			        					<span>Componente</span>
			        					<select className="form-control" disabled  value={item.unit !== undefined ? item.unit.blood_component_id : ''}>
										{this.state.blood_component_list.map((item, i)=>{
											return <option key={i} value={item.component.id}>
												{item.component.component}
											</option>
										})}
										</select>

			        				</div>
			        				
			        			
			        				<div className="col-xs-12 col-sm-2">
			        					<span>Grupo y RH</span>
			        					<input value={item.unit !== undefined ? 
			        						item.unit_entries.rh === 'POSITIVO' ? 
			        							item.unit_entries.group+'+': 
			        						item.unit_entries.rh === 'NEGATIVO' ? 
			        							item.unit_entries.group+'-' :
			        						item.unit_entries.group
			        						: '' } className="form-control" disabled />
			        				</div>
			        				<div className="col-xs-12 col-sm-2">
			        					<span>Volumen</span>
			        					<input value={item.unit !== undefined ? item.unit.volume : ''} className="form-control" disabled />
			        				</div>
			        				<div className="col-xs-12 col-sm-2">
			        					<span>Fecha de Caducidad</span>
			        					<input value={item.unit !== undefined ? moment(item.unit.caducidad, 'YYYY-MM-DD').format('DD/MM/YYYY') : ''} className="form-control" disabled />
			        				</div>
			        			</div>
			        			<div className="col-xs-12">
			        				<div className="col-xs-12" style={{padding:'0'}}>
			        					<span>Observaciones</span>
			        					<textarea value={item.unit !== undefined ? item.unit_entries.observations : ''} className="form-control" disabled style={{resize:'none'}} />
			        				</div>
			        			</div>
		        			</fieldset>
			        		<fieldset className="col-xs-12">
			        			<legend>Donador</legend>
			        			<div className="col-xs-12">
			        				<div className="col-xs-12 col-sm-4">
			        					<span>Nombre</span>
			        					<input value={item.unit !== undefined ? item.unit_entries.names : ''} className="form-control" disabled />
			        				</div>
			        				<div className="col-xs-12 col-sm-4">
			        					<span>Apellido Paterno</span>
			        					<input value={item.unit !== undefined ? item.unit_entries.lastname1 : ''} className="form-control" disabled />
			        				</div>
			        				<div className="col-xs-12 col-sm-4">
			        					<span>Apellido Materno</span>
			        					<input value={item.unit !== undefined ? item.unit_entries.lastname2 : ''} className="form-control" disabled />
			        				</div>
			        			</div>
			        		</fieldset>
			        		{this.state.show_patient ?
			        			<fieldset className="col-xs-12">
			        				<legend>Paciente</legend>
			        				<div className="col-xs-12">
				        				<div className="col-xs-12 col-sm-4">
				        					<span>Nombre</span>
				        					<input value={item.person !== undefined ? 
				        						item.person.names : ''} className="form-control" disabled />
				        				</div>
				        				<div className="col-xs-12 col-sm-2">
				        					<span>Apellido Paterno</span>
				        					<input value={item.person !== undefined ? 
				        						item.person.lastname1 : ''} className="form-control" disabled />
				        				</div>
				        				<div className="col-xs-12 col-sm-2">
				        					<span>Apellido Materno</span>
				        					<input value={item.person !== undefined ? 
				        						item.person.lastname1 : ''} className="form-control" disabled />
				        				</div>
				        				<div className="col-xs-12 col-sm-2">
				        					<span>No. Expediente</span>
				        					<input value={item.patient !== undefined ? 
				        						item.patient.number : ''} className="form-control" disabled />
				        				</div>
				        				<div className="col-xs-12 col-sm-2">
				        					<span>Grupo y RH</span>
				        					<input value={item.person !== undefined ? 
				        						item.person.lookup_rh === 'POSITIVO' ? 
				        							item.person.lookup_group+'+': 
				        						item.person.lookup_rh === 'NEGATIVO' ? 
				        							item.person.lookup_group+'-' :
				        						item.person.lookup_group
				        						: '' } className="form-control" disabled />
				        				</div>
				        			</div>
				        			<div className="col-xs-12">
				        				<div className="col-xs-12 col-sm-4">
				        					<span>Hospital</span>
				        					<select className="form-control" disabled value={item.patient !== undefined ? item.patient.national_center_id : ''}>
										        {this.state.national_centers.map(function(t) {
								                  	return <option key={t.id}  value={t.id} >{t.name} </option>;
								                })}
							              	</select>
				        				</div>
				        				<div className="col-xs-12 col-sm-2">
				        					<span>Servicio</span>
				        					<input value={item.patient !== undefined ? 
				        						item.patient.national_name : ''} className="form-control" disabled />
				        				</div>

				        				<div className="col-xs-12 col-sm-2">
				        					<span>Parentesco</span>
				        					<select className="form-control" disabled value={ item.patient !== undefined ? item.patient.relationship :'' }>
								                {this.state.relationships.map(function(t) {
								                  	return <option key={t.id}  value={t.key} >{t.name} </option>;
								                })}
							              	</select>
				        				</div>
				        			</div>
			        			</fieldset>
			        		:null}
			        		{item.unit_entries_has_biometrics !== undefined ?
				        		<fieldset className="col-xs-12">
				        			<legend>Biometría Hemática</legend>
				        			{this.state.biometrics.map( (t, index) => (
										<div className="col-xs-12 col-sm-2" style={{padding:"2px 2px 2px 8px",overflow:"hidden"}} key={index}>
											<span className="size-min" style={{whiteSpace:"nowrap"}}>{t.name}</span>
											{item.unit_entries_has_biometrics.map((bio, i)=>{
												return t.id === bio.biometrics_id ?
													<input key={i} value={bio.value} className="form-control bio_extraction" disabled />
												: null
											})}
											
										</div>
									))}

				        		</fieldset>
			        		: null}
			        		<fieldset className="col-xs-12">
			        			<legend>Pruebas Analiticcas</legend>
			        			<div className="col-xs-12 col-sm-6">
			        				<Table responsive hover>
			        					<thead>
				        					<tr>
				        						<th>Pruebas Obligatorias</th>
				        					</tr>
			        					</thead>
			        					<tbody>
			        						{this.state.table_required.map((obj, i)=>{
			        							return <tr key={i}>
			        								<td>
			        									<div className="col-xs-12 col-sm-8">
			        										{obj.name}
			        									</div>
			        									<div className="col-xs-12 col-sm-4">
			        										<input value={obj.value} className="form-control" disabled  />
			        									</div>
			        								</td>
			        							</tr>
			        						})}
			        					</tbody>
			        				</Table>
			        			</div>
			        			<div className="col-xs-12 col-sm-6">
			        				<Table responsive hover>
			        					<thead>
				        					<tr>
				        						<th>Otras Pruebas</th>
				        					</tr>
			        					</thead>
			        					<tbody>
			        						{item.other_analitical_test !== undefined ?
			        							item.other_analitical_test.map((obj, i)=>{
				        							return <tr key={i}>
				        								<td>
				        									<div className="col-xs-12 col-sm-8">
				        										{obj.analitical_test.name}
				        									</div>
				        									<div className="col-xs-12 col-sm-4">
				        										<input value={obj.value} className="form-control" disabled  />
				        									</div>
				        								</td>
				        							</tr>
				        						})
			        						: null}
			        					</tbody>
			        				</Table>
			        			</div>
			        		</fieldset>
		        		</div>
		        	</div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.close')}  onClick={this.handleClose}/>
		        </Modal.Footer>
		    </Modal>
		)
	}
}

export default translate('translations') (ModalInfo);
